<app-header></app-header>

<section class="container-xxl">

    <!-- BREADCRUMB AREA - STARTS --> 
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div> 
    <!-- BREADCRUMB AREA - ENDS -->
 
    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
            <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                <div [style]="navmenuloadCss">
                    <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                  </div>
            </div>
            <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                        <h2 class="screen-reader" id="vigilanceTable">{{ 'VigilanceContactDirectory' | translate }}</h2>
                                    </div>
                                    <div class="description">
                                        <div class="tenders">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <!-- search section -->
                                                    <div class="searchpanel notific-frm" *ngIf="issearch == true || isdisplay == true">
                                                        <form [formGroup]="searchForm" (ngSubmit)="searchContact()">
                                                            <div class="row">
                                                            
                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ "FullName" | translate }}</b>
                                                                        </label>
                                                                        <input type="text" formControlName="name" #name class="form-control screen-reader" >
                                                                    </div>
                                                                </div>

                                                                <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ "Designation" | translate }}</b>
                                                                        </label>
                                                                        <input type="text" formControlName="designation" #designation class="form-control screen-reader" >
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    class="col-xl-2 col-md-12 col-sm-6 col-xs-12 d-flex align-items-end">
                                                                    <div class="mt-3">
                                                                        <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'"
                                                                            class="btn btn-outline-success screen-reader"
                                                                            [disabled]="ifdisabled"
                                                                            [innerHTML]="btncontent">
                                                                        </button>
                                                                        <div *ngIf="RefreshBtn">
                                                                            <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'"
                                                                                class="btn btn-outline-secondary py-0-2 screen-reader"
                                                                                (click)="RefreshPage()">
                                                                                <i class="bi bi-arrow-repeat fs-5"
                                                                                    aria-hidden="true"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div> 

                                                            </div>
                                                        </form>
                                                    </div>
                                                    <!-- search section -->

                                                    <!-- tender section area -->


                                                    <div class="table-responsive font-adjust">
                                                        <table class="table" aria-describedby="vigilanceTable"  *ngIf="contactList.length > 0; else noDataTemplate" >
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th class="screen-reader" scope="col">#</th>
                                                                    <th class="screen-reader" scope="col">{{ "FullName" | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ "Designation" | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'PhoneNumber' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'FaxNumber' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'EmailId' | translate }}</th>
                                                                </tr>
                                                            </thead> 
                                                            <tbody>
                                                             
                                                                <tr *ngFor="let i= index; let item of contactList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};;">
                                                                    <td class="screen-reader">{{ i+1 }}</td>
                                                                    <td class="screen-reader">{{ language=='English'?item.name:item.nameInHindi }}</td>
                                                                    <td class="screen-reader">{{ language=='English'?item.designation:item.designationInHindi}}</td>
                                                                    <td class="screen-reader">
                                                <span *ngFor="let contact of item.addPhoneNumber; let x=index">
                                                    {{ language=='English'?contact.phoneNumber:contact.phoneNumberInHindi}}
                                                    <ng-container *ngIf="item.addPhoneNumber.length != (x+1)">,<br></ng-container>
                                                </span>
                                                                    </td>
                                                                    <td class="screen-reader">
                                                        <span *ngFor="let contact of item.addFaxNumber; let x=index">
                                                            {{ language=='English'?contact.faxNumber:contact.faxNumberInHindi }}
                                                            <ng-container *ngIf="item.addFaxNumber.length != (x+1)">,<br></ng-container>
                                                        </span>

                                                                    </td>
                                                                    <td class="screen-reader">
                                                                        <span *ngFor="let email of item.addEmailId; let i=index">
                                                                            {{ email.emailId | mailView }}
                                                                            <ng-container *ngIf="item.addEmailId.length != (i+1)">,<br></ng-container>
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table> 
                                                        <ng-template #noDataTemplate>

                                                            <p class="screen-reader font-adjust" [style.text-align]="'center'"><b>No data available.</b>
                                                            </p>
        
                                                        </ng-template>
                                                        <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 10"></pagination-controls>
                                                    </div>


 
                                                    <!-- tender section area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>